<template>
  <div>
    <v-btn :color="color" text @click="dialog = true;" v-if="noButton === false">
      {{ label }}
    </v-btn>

    <v-dialog scrollable v-model="dialog" max-width="700px" :fullscreen="fullscreen">
      <v-card class="select-personas-dialog">
        <v-card-title class="headline primary darken-2" dark primary-title>
          <v-layout column wrap>
            <div class="d-flex">
              <span class="num mr-3 mt-2 white--text">{{personasSelected.length}}</span>
              <v-text-field
                label="Buscar"
                v-model="searchInput"
                solo-inverted
                dark
                flat
                clearable
                hide-details
                append-icon="search"
              ></v-text-field>
              <v-btn small icon class="ml-4" color="white" @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div class="d-flex mt-2">
              <v-btn color="white" text x-small @click="toggleForm()">Agregar nuevo</v-btn>
              <v-flex></v-flex>
              <v-btn color="white" text x-small @click="clearSelect(3)">Deseleccionar</v-btn>
            </div>
          </v-layout>
          <!--
          <v-btn
            fab
            small
            color="primary darken-1"
            class="btn-form"
            :class="{rotate: showedForm}"
            absolute
            @click="toggleForm()"
          >
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        -->
        </v-card-title>

        <v-card-text style="" class="px-0 my-1">
          <v-row>
            <v-col class="grow">
              <v-expand-transition>
                <v-card
                  dark
                  tile
                  flat
                  color="grey darken-1"
                  v-show="showedForm && searchInput == ''">
                  <v-card-title primary-title>
                    <div>
                      <h3 class="subtitle-1 mb-0">Nueva persona</h3>
                    </div>
                  </v-card-title>
                  <v-card-text class="py-0">
                    <v-form class="d-flex" ref="form" lazy-validation>
                      <v-container class="py-0">
                        <v-row no-gutters>
                          <v-col :cols="12" :sm="2">
                            <!--
                            <v-autocomplete
                              v-model="newPerson.cod"
                              label="Código"
                              :items="codigos"
                              item-text="cod"
                              return-object
                              dense
                              hide-no-data
                            ></v-autocomplete>
                          -->
                            <v-text-field
                              v-model="newPerson.cod"
                              :counter="10"
                              label="Código"
                              required
                              class="mr-4"
                            ></v-text-field>
                          </v-col>

                          <v-col :cols="12" :sm="10" :md="6">
                            <v-text-field
                              v-model="newPerson.nombre"
                              :counter="50"
                              label="Nombre"
                              required
                              class="mr-4"
                            ></v-text-field>
                          </v-col>
                          <v-col :cols="12" :sm="6" :md="4">
                            <v-text-field
                              v-model="newPerson.rut"
                              v-rut:live
                              label="RUT"
                              required
                              class="mr-4"
                            ></v-text-field>
                          </v-col>
                          <v-col :cols="12" :sm="6" :md="4">
                            <v-text-field
                              v-model="newPerson.valorDia"
                              label="Valor x Día"
                              prefix="$"
                              required
                              class="mr-4"
                            ></v-text-field>
                          </v-col>
                          <v-col :cols="12" :sm="6" :md="4">
                            <v-text-field
                              v-model="newPerson.horasExtras"
                              label="Valor horas extras"
                              prefix="$"
                              required
                              class="mr-4"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="d-flex justify-end pt-0">
                    <v-btn text color="white" @click="cancelForm()">Cancelar</v-btn>
                    <v-btn text color="white">Agregar Persona</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expand-transition>
            </v-col>
          </v-row>

          <v-list-item-group
            v-model="personasSelected"
            multiple
            active-class="">
            <v-list-item
              dense
              v-for="(persona, indexPerson) in personasComputed"
              :key="persona.nombre+'-'+indexPerson"
              :disabled="persona.disabled"
              :value="persona">
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox v-model="active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>
                    <div class="d-flex">
                      <span> {{ persona.cod }} - {{ persona.nombre}} </span>
                      <v-flex></v-flex>
                      <span
                        class="ml-7 font-italic caption orange--text lighten-3"
                        v-show="persona.disabled">
                        Persona ya agregada</span>
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >{{ persona.rut }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="cancel()">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="selectPersonas()">
            Listo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import _ from 'lodash';

export default {
  name: "selectPersonas",
  props: {
    color    : {},
    personas : {default:() => []},
    disabled : {default:() => []},
    label    : {},
    noButton : {default: false},
    value    : {},
    fullscreen:{default:false, type: Boolean}
  },
  data: () => ({
    dialog           : false,
    personasSelected : [],
    searchInput      : "",
    newPerson        : {
      cod         : "",
      nombre      : "",
      rut         : "",
      valorDia    : 0,
      horasExtras : 0
    },
    showedForm : false,
    nameRules  : [
      v => !!v || "Name is required",
      v => (v && v.length <= 10) || "Name must be less than 10 characters"
    ]
  }),
  watch:{
    value(){
      this.dialog = this.value;
    },
    dialog(){
      this.$emit("input", this.dialog);
      this.personasSelected = [];
    }
  },
  computed: {
    personasComputed() {
      var self = this;
      return this.personas.filter(persona => {
        //persona.obj = _.cloneDeep(persona); //   <<<------------- modifica, no funciona bien en filtros
        if (self.disabled && self.disabled.indexOf(persona) > -1) {
          persona.disabled = true;
        } else {
          persona.disabled = false;
        }
        //buscador
        if (self.searchInput) {
          var t = persona.cod + " " + persona.nombre;
          return t.toLowerCase().includes(self.searchInput.toLowerCase());
        }
        return true;
      });
    },
    codigos() {
      var codigos = [];
      this.personas.forEach(persona => {
        codigos.push(persona.cod);
      });
      return codigos;
    }
  },
  methods: {
    selectPersonas() {
      this.dialog = false;
      var personas = [];
      this.personasSelected.forEach(personaSelected => {
        //personas.push(personaSelected.obj);
        personas.push(personaSelected);
      });
      this.$emit("selected", personas);
    },
    cancel() {
      this.dialog = false;
    },
    clearSelect() {
      this.personasSelected.splice(0, this.personasSelected.length);
    },

    //FORM
    validate() {
      if (this.$refs.form.validate()) {
        //this.snackbar = true
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    cancelForm() {
      this.showedForm = false;
      this.resetValidation();
    },
    showForm() {
      this.showedForm = true;
    },
    toggleForm() {
      this.showedForm = !this.showedForm;
    },
    saveForm() {}
  }
};
</script>
<style lang="scss" scoped>
.select-personas-dialog {
  .v-card__title {
    position: relative;
  }
}

.btn-form {
  bottom: -10px;
  left: 50%;
  right: 50%;
  top: unset !important;
  .v-icon {
    transition: 0.5s all ease;
  }
  &.rotate{
    .v-icon {
      transform: rotate(180deg);
    }
  }
}
</style>
